import React, { SyntheticEvent } from 'react';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import { translateBlock } from 'i18n';

type Props = {
    selectedMetric: QueryMetricT;
    onChange: (event: SyntheticEvent, metricField: string) => void;
    uniqueModels: string[];
    metrics: QueryMetricT[];
};

const ModalHeader = ({
    selectedMetric,
    onChange,
    uniqueModels,
    metrics,
}: Props): React.ReactElement => {
    const getModel = (metric: { field: string }) => metric.field.split('.')[0];
    const getFirstMetricForUniqueModel = (uniqueModel: string) =>
        metrics.filter((m) => getModel(m) === uniqueModel)[0];
    return (
        <AppBar position="static">
            <Tabs
                value={selectedMetric.field}
                onChange={onChange}
                sx={{ backgroundColor: 'white' }}
                indicatorColor="primary"
                textColor="primary"
            >
                {uniqueModels.map((model) => (
                    <Tab
                        key={model}
                        value={getFirstMetricForUniqueModel(model).field}
                        label={
                            <Typography variant="body1SemiBold">
                                {translateBlock(model)}
                            </Typography>
                        }
                    />
                ))}
            </Tabs>
        </AppBar>
    );
};

const MemoModalHeader = React.memo<Props>(ModalHeader);
export default MemoModalHeader;
